import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import SystemRoutes from './SystemRoutes';
import { GA4_MEASUREMENT_ID } from '../config';
import Header from '../components/header';
import Footer from '../components/footer';
import { ShortenFAB, ScrollToTopButton } from '../components/general';

const Router = () => {

    const location = useLocation();

    // Send page_view events to GA4 on route changes
    useEffect(() => {
        if (GA4_MEASUREMENT_ID) {
            ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
        }
    }, [location]);

    return (
        <>
            <Header />
            <SystemRoutes />
            <AddOns />
            <Footer />
        </>
    );
}

const AddOns = () => {
    return (
        <>
            <ShortenFAB /> 
            <ScrollToTopButton />
        </>
    );
}

export default Router;